import { signal, computed } from "@preact/signals";
import type { MedusaProduct } from "src/types";

export const accessory = signal<MedusaProduct | null>(null);
export const accessoryQuantity = signal<0 | 1>(0);
export const accessoryPrice = computed(
    () => (accessory.value?.variants[0]?.prices?.[0]?.amount || 0) / 100,
  );
